<template>
  <div class="p-fluid">
    <div class="p-col-12 p-lg-12">
      <div class="card card-w-title">
        <div class="row manager-title-row">
          <div class="p-col-4 manager-title-custom">{{ title }}</div>
        </div>
        <!-- <div class="note">(*) Nội dung không được bỏ trống</div> -->
        <formEdit
          :key="componentKey"
          :mode="mode"
          @back="backToList"
          @save="saveData"
          :triggerSave.sync="triggerSave"
          :model="models"/>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import DataServices from '@/core/DataServices'
import formEdit from './add'
import gql from "graphql-tag";
export default {
  components: {
    formEdit
  },
  data() {
    return {
      users: null,
      validationErrors: [],
      title: "Create new booking",
      mode: 'add',
      models: {},
      componentKey: 0,
      accountID: '',
      page_transaction:null,
      active_check:true,
      users_clubs_id : '',
      time_zone_local : moment.tz.guess(true),
      triggerSave: false
    }
  },
  async mounted () {
    console.log("this.$route.name:",this.$route.query.page_transaction);
    this.mode = this.$route.name === 'editBooking' ? 'edit' : this.mode;
    this.title = this.mode === 'edit' ? 'Edit' : this.title;
    if (this.$route.params.id !== undefined) await this.getData(this.$route.params.id);
    if (!this.$commonFuction.isEmpty(this.$route.query)){
      if (!this.$commonFuction.isEmpty(this.$route.query.page_transaction)){
        this.page_transaction = this.$route.query.page_transaction;
      }
    }
    //check quyền
    var arr_role = await this.$CoreService.checkPermission(this.$constants.KEY_MENU.LIST_BOOKING);
    if (this.mode == 'edit'){
      if (arr_role.indexOf(this.$constants.ROLE.EDIT) < 0){
        this.$router.push({path: this.$constants.URL_ERR.FOBIDDEN});
      }
    }else {
      if (arr_role.indexOf(this.$constants.ROLE.ADD) < 0){
        this.$router.push({path: this.$constants.URL_ERR.FOBIDDEN});
      }
    }
  },
  methods: {
    getIsoWeekMeta(dateInput) {
      const normalizedDate = moment(moment(dateInput).format('YYYY-MM-DD'), 'YYYY-MM-DD');
      return {
        week_number: normalizedDate.isoWeek(),
        week_year: normalizedDate.isoWeekYear(),
        date_start: normalizedDate.format('YYYY-MM-DD')
      };
    },
    buildWeekKey(week) {
      if (!week) {
        return null;
      }
      if (week.id) {
        return `id:${week.id}`;
      }
      return `${moment(week.date_start).format("YYYY-MM-DD")}_${moment(week.date_end).format("YYYY-MM-DD")}`;
    },
    getRoundWeeks(round, prefix = '') {
      return [
        round?.[`${prefix}week`] ?? null,
        round?.[`${prefix}week_1`] ?? null
      ].filter(Boolean);
    },
    isSameWeekRef(weekA, weekB) {
      if (!weekA || !weekB) {
        return false;
      }
      if (weekA?.id && weekB?.id) {
        return weekA.id === weekB.id;
      }
      if (weekA?.index_week_id && weekB?.index_week_id) {
        return weekA.index_week_id === weekB.index_week_id;
      }
      return this.buildWeekKey(weekA) === this.buildWeekKey(weekB);
    },
    hasRoundWeekChanged(round) {
      const originalWeeks = this.getRoundWeeks(round, 'original_');
      const currentWeeks = this.getRoundWeeks(round);
      if (originalWeeks.length !== currentWeeks.length) {
        return true;
      }
      return originalWeeks.some((week) => !currentWeeks.some((item) => this.isSameWeekRef(week, item)));
    },
    getRemovedWeeks(round) {
      const originalWeeks = this.getRoundWeeks(round, 'original_');
      const currentWeeks = this.getRoundWeeks(round);
      return originalWeeks.filter((week) => !currentWeeks.some((item) => this.isSameWeekRef(week, item)));
    },
    getAddedWeeks(round) {
      const originalWeeks = this.getRoundWeeks(round, 'original_');
      const currentWeeks = this.getRoundWeeks(round);
      return currentWeeks.filter((week) => !originalWeeks.some((item) => this.isSameWeekRef(week, item)));
    },
    async releaseRemovedVisitWeeks(round, propertyId) {
      const removedWeeks = this.getRemovedWeeks(round);
      if (removedWeeks.length === 0) {
        return;
      }
      const currentUser = this.$store.getters.user;
      const now = moment(new Date());
      for (let i = 0; i < removedWeeks.length; i++) {
        const week = removedWeeks[i];
        const indexWeekId = week?.index_week_id ?? null;
        if (this.$commonFuction.isEmpty(indexWeekId)) {
          continue;
        }
        const { data } = await this.$apollo.query({
          query: DataServices.getList('visit', { fields: 'id status owner_id uid index_week_id' }),
          variables: {
            where_key: {
              deleted: { _eq: false },
              property_id: { _eq: propertyId },
              index_week_id: { _eq: indexWeekId },
              owner_id: { _eq: round?.uid }
            },
            orderBy: [{ created_at: 'asc' }]
          },
          fetchPolicy: 'network-only'
        });
        const existingVisits = data?.[Object.keys(data)[0]] ?? [];
        if (existingVisits.length === 0) {
          continue;
        }
        const currentVisit = existingVisits[0];
        if (currentVisit?.status !== 'ST001') {
          throw new Error('ONLY_NOT_PLAN_YET_CAN_REMOVE');
        }
        await this.$apollo.mutate({
          mutation: DataServices.updateData('visit'),
          variables: {
            data_update: {
              uid: null,
              owner_id: null,
              is_maintenance: true,
              status: 'ST001',
              updated_at: now,
              updated_by: currentUser
            },
            where_key: {
              id: { _eq: currentVisit.id }
            }
          }
        });
      }
    },
    async assignAddedVisitWeeks(round, propertyId) {
      const addedWeeks = this.getAddedWeeks(round);
      if (addedWeeks.length === 0) {
        return;
      }
      const currentUser = this.$store.getters.user;
      const now = moment(new Date());
      for (let i = 0; i < addedWeeks.length; i++) {
        const week = addedWeeks[i];
        const indexWeekId = week?.index_week_id ?? null;
        if (this.$commonFuction.isEmpty(indexWeekId)) {
          continue;
        }
        const { data } = await this.$apollo.query({
          query: DataServices.getList('visit', { fields: 'id owner_id uid index_week_id' }),
          variables: {
            where_key: {
              deleted: { _eq: false },
              property_id: { _eq: propertyId },
              index_week_id: { _eq: indexWeekId },
              owner_id: { _is_null: true }
            },
            orderBy: [{ created_at: 'asc' }]
          },
          fetchPolicy: 'network-only'
        });
        const ownerlessVisits = data?.[Object.keys(data)[0]] ?? [];
        if (ownerlessVisits.length > 0) {
          await this.$apollo.mutate({
            mutation: DataServices.updateData('visit'),
            variables: {
              data_update: {
                uid: round?.uid,
                owner_id: round?.uid,
                is_maintenance: false,
                status: 'ST001',
                updated_at: now,
                updated_by: currentUser
              },
              where_key: {
                id: { _eq: ownerlessVisits[0].id }
              }
            }
          });
        } else {
          await this.$apollo.mutate({
            mutation: DataServices.insertData('visit'),
            variables: {
              objects: {
                uid: round?.uid,
                owner_id: round?.uid,
                property_id: propertyId,
                week_number: week?.week_number ?? null,
                visit_start: week?.date_start ?? null,
                visit_end: week?.date_end ?? null,
                status: 'ST001',
                type: '1',
                index_week_id: indexWeekId,
                is_maintenance: false,
                created_at: now,
                updated_at: now,
                created_by: currentUser,
                updated_by: currentUser
              }
            }
          });
        }
      }
    },
    getAssignedWeekKeys(booking_round = []) {
      const assignedWeekKeys = new Set();
      booking_round.forEach((rounds) => {
        (rounds ?? []).forEach((round) => {
          const weekKey = this.buildWeekKey(round?.week);
          const week1Key = this.buildWeekKey(round?.week_1);
          if (weekKey) {
            assignedWeekKeys.add(weekKey);
          }
          if (week1Key) {
            assignedWeekKeys.add(week1Key);
          }
        });
      });
      return assignedWeekKeys;
    },
    async syncMaintenanceVisits(params) {
      const propertyId = params?.property?.id ?? null;
      const propertyWeeks = Array.isArray(params?.property_weeks) ? params.property_weeks : [];
      if (this.$commonFuction.isEmpty(propertyId) || propertyWeeks.length === 0) {
        return;
      }

      const bookingIndexWeekIds = propertyWeeks
        .map((week) => {
          if (week?.index_week_id) {
            return week.index_week_id;
          }
          if (!week?.date_start) {
            return null;
          }
          const weekMeta = this.getIsoWeekMeta(week.date_start);
          return `${weekMeta.week_number}${weekMeta.week_year}`;
        })
        .filter((item, index, arr) => !!item && arr.indexOf(item) === index);
      const maintenanceWeeks = Array.isArray(params?.maintenance_weeks)
        ? params.maintenance_weeks.filter((week) => week?.is_maintenance === true)
        : [];
      const selectedMaintenanceIndexWeekIds = maintenanceWeeks
        .map((week) => week?.index_week_id ?? null)
        .filter((item, index, arr) => !!item && arr.indexOf(item) === index);
      const currentUser = this.$store.getters.user;
      const now = moment(new Date());

      if (bookingIndexWeekIds.length === 0) {
        return;
      }

      const { data } = await this.$apollo.query({
        query: DataServices.getList('visit', { fields: 'id index_week_id is_maintenance owner_id uid' }),
        variables: {
          where_key: {
            deleted: { _eq: false },
            property_id: { _eq: propertyId },
            owner_id: { _is_null: true },
            index_week_id: { _in: bookingIndexWeekIds }
          }
        },
        fetchPolicy: 'network-only'
      });

      const existingVisits = data?.[Object.keys(data)[0]] ?? [];
      const mapExistingVisit = {};
      existingVisits.forEach((item) => {
        if (item?.index_week_id && this.$commonFuction.isEmpty(mapExistingVisit[item.index_week_id])) {
          mapExistingVisit[item.index_week_id] = item;
        }
      });

      await Promise.all(existingVisits.map((visit) => {
        const nextMaintenance = selectedMaintenanceIndexWeekIds.indexOf(visit.index_week_id) >= 0;
        return this.$apollo.mutate({
          mutation: DataServices.updateData('visit'),
          variables: {
            data_update: {
              is_maintenance: nextMaintenance,
              updated_at: now,
              updated_by: currentUser
            },
            where_key: {
              id: { _eq: visit.id }
            }
          }
        });
      }));

      const maintenanceWeeksNeedCreate = maintenanceWeeks.filter((week) => !mapExistingVisit[week.index_week_id]);
      if (maintenanceWeeksNeedCreate.length === 0) {
        return;
      }

      await Promise.all(maintenanceWeeksNeedCreate.map((week) => {
        const weekMeta = this.getIsoWeekMeta(week.date_start || week.visit_start);
        const dateEnd = moment(week.date_end || week.visit_end).format("YYYY-MM-DD");
        return this.$apollo.mutate({
          mutation: DataServices.insertData('visit'),
          variables: {
            objects: {
              property_id: propertyId,
              week_number: weekMeta.week_number,
              visit_start: weekMeta.date_start,
              visit_end: dateEnd,
              status: 'ST003',
              type: '1',
              is_maintenance: true,
              index_week_id: week.index_week_id ?? `${weekMeta.week_number}${weekMeta.week_year}`,
              created_at: now,
              updated_at: now,
              created_by: currentUser,
              updated_by: currentUser
            }
          }
        });
      }));
    },
    backToList() {
      this.$router.push({ path: '/admin/list-booking' });
    },
    UpdateActive(key){
      // console.log("key",key)
      var uid = this.$route.params.id;
      this.$commonFuction.is_loading(true);
      if(key == 'lock'){
        this.active_check = false
      }else{
        this.active_check = true
      }

      let variables = {
        'data_update': {
          'active': this.active_check
        },
        'where_key': {
          'id': {'_eq': this.$route.params.id}
        }
      };
      var that = this;
      this.$apollo.mutate({
        mutation: DataServices.updateData('users'),
        variables: variables
      }).then(async (res) => {
        console.log('Success',res);
        if(key == 'lock'){
          var query_t =  `mutation {
            delete_jwt_token(where: { uid: {_eq: "${uid}"}}) {
              returning {
                id
              }
            }
          }`
          await that.$apollo.mutate({
            mutation: gql(query_t),
          })
        }
        that.$toast.add({ severity: 'success', summary: 'Success', detail: 'Save data successfully', life: 3000 })
      })
      this.$commonFuction.is_loading(false);
      // console.log("this.$route.params.id",this.$route.params.id)
    },
    async saveData(params) {
      // console.log("params",params)
      let objects = {
        property_id: params.property?.id,
        start_visit_date: params.start_visit_date.format("YYYY-MM-DD"),
        end_visit_date: params.end_visit_date.format("YYYY-MM-DD"),
        start_booking_date: params.start_booking_date.format("YYYY-MM-DD"),
        end_booking_date: params.end_booking_date.format("YYYY-MM-DD"),
        updated_at: moment(new Date()),
        updated_by: this.$store.getters.user
      }
      var booking_round = params.booking_round;
      this.triggerSave = false;
      // var days = 14;
      if(this.mode == 'add'){
        objects.created_at = moment(new Date());
        objects.created_by = this.$store.getters.user;
        await this.$apollo.mutate({
            mutation: DataServices.insertData('booking'),
            variables: {
              objects: objects
            }
        }).then(async (res) => {
            // console.log("res",res);
            if (res.data[Object.keys(res.data)].affected_rows) {
              var returning = res.data[Object.keys(res.data)].returning[0];
              // let diff_date = params.end_visit_date.diff(params.start_visit_date, 'days');
              // let start_of_week = params.start_visit_date.startOf('week').day('Monday');
              // let end_of_week = moment(moment(start_of_week).add(13, 'days').format('YYYY/MM/DD')).endOf('week').day(0);
              // let date_week_arr = [{start: start_of_week, end: end_of_week}];
              // for(let i=1; i <= diff_date; i++) {
              //   if(i%days==0 && i != diff_date) {
              //     let start_d = moment(end_of_week.add(2, 'days').format('YYYY/MM/DD')).startOf('week').day('Monday');
              //     // moment(moment(params.start_visit_date).add((i+h), 'days').startOf('week').day('Monday').format('YYYY/MM/DD'));
              //     end_of_week = moment(moment(start_d).add(13, 'days').format('YYYY/MM/DD')).endOf('week').day(0)
              //     date_week_arr.push({start: start_d, end: end_of_week});
              //   }
              // }
              var date_week_arr = this.calculatePeriods(new Date(params.start_visit_date.format("YYYY-MM-DD")), new Date(params.end_visit_date.format("YYYY-MM-DD")));
              console.log("date_week_arr", date_week_arr);
              date_week_arr.map(async m => {
                const weekMeta = this.getIsoWeekMeta(m.start);
                let obj_w = {
                  week_number: weekMeta.week_number,
                  date_start: weekMeta.date_start,
                  date_end: moment(m.end).format("YYYY-MM-DD"),
                  booking_id: returning.id,
                  property_id: params.property?.id,
                  index_week_id: `${weekMeta.week_number}${weekMeta.week_year}`
                }
                await this.$apollo.mutate({
                    mutation: DataServices.insertData('property_week'),
                    variables: {
                      objects: obj_w
                    }
                }).catch(async error => {
                    console.log('error', error);
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                        detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
                        life: 3000
                    });
                });
              })
              //gui push
              console.log(" booking_round[0]",  booking_round);
              var list_user = (booking_round.length > 0) ? booking_round.map(m => m[0]?.uid) : [];
               console.log("list_user", list_user);
              //check trùng user
              list_user = list_user.filter((item, index) => list_user.indexOf(item) === index);
             
              // console.log("list_user111", list_user);
               var property_name = params?.property?.name_root ?? '';
              // for (let i=0;i < list_user.length; i++) {
                
              // }
              var params_noti ={
                title:"",
                content:"",
                is_use_en:true,
                title_en:"",
                content_en:"",
                short_content:`${property_name} Årets bookingsrunde er nu åben. Se tidsplanen i appen og book dine uger indenfor tidsfristen på 24 timer.`,
                short_content_noti:`<b>${property_name}</b> Årets bookingsrunde er nu åben. Se tidsplanen i appen og book dine uger indenfor tidsfristen på 24 timer.`,
                short_content_en:`${property_name} We've set up this year's booking round for you! Please keep an eye on the schedule and start booking when you're ready.`,
                short_content_noti_en:`<b>${property_name}</b> We've set up this year's booking round for you! Please keep an eye on the schedule and start booking when you're ready.`,
                type:null,
                action_key:this.$constants.ACTION_KEY_NOTI.BOOKING_ROUND_DETAIL,
                uid:null,
                multi_uid:list_user,
                object_id:params.property?.id,
                is_admin:false,
                key_noti:3,
              }
               await this.$CoreService.sendNoti(params_noti);
              if (booking_round.length > 0) {
                for (let i=0;i < booking_round.length; i++) {
                  for (let j=0;j < booking_round[i].length; j++) {
                    let obj = {
                      // week_id: booking_round[i][j]?.week?.id,
                      round: `${booking_round[i][j]?.round}`,
                      ordinal: booking_round[i][j]?.ordinal,
                      status: booking_round[i][j]?.status ?? 'ST005',
                      part_id: booking_round[i][j]?.part_id,
                      part_number: booking_round[i][j]?.part_number,
                      uid: booking_round[i][j]?.uid,
                      booking_id: returning.id
                    };
                    if (booking_round[i][j]?.round == 1 && booking_round[i][j]?.ordinal == 1) {
                      obj.date_start_book = params?.property?.time_zone ? moment.tz(params.start_visit_date, params?.property?.time_zone).format('YYYY/MM/DD') : params.start_visit_date;
                    }
                    await this.$apollo.mutate({
                        mutation: DataServices.insertData('booking_round'),
                        variables: {
                          objects: obj
                        }
                    }).then(async () => {
                      if ((i+1) == booking_round.length && (j+1) == booking_round[i].length) {
                        this.redirectEdit();
                      }
                    }).catch(async error => {
                        console.log('error', error);
                        this.$toast.add({
                            severity: 'error',
                            summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                            detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
                            life: 3000
                        });
                        this.$commonFuction.is_loading(false);
                    });
                  }
                }
              } else {
                this.redirectEdit();
              }
            }
        }).catch(async error => {
            console.log('error', error);
            this.$toast.add({
                severity: 'error',
                summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
                life: 3000
            });
            this.$commonFuction.is_loading(false);
        });
      }else{
        // var user_id = this.$route.params.id;
        let variables = {
          'data_update': objects,
          'where_key': {
            'id': {'_eq': this.models.id}
          }
        }
        await this.$apollo.mutate({
            mutation: DataServices.updateData('booking'),
            variables: variables
        }).then(async (res) => {
            // console.log("res",res);
            if (res.data[Object.keys(res.data)].affected_rows) {
              var returning = res.data[Object.keys(res.data)].returning[0];
              // let checkRound = 0;
              // if (booking_round.length > 0) {
              //   for (let i=0;i < booking_round.length; i++) {
              //     for (let j=0;j < booking_round[i].length; j++) {
              //       if (booking_round[i][j]?.week?.id) {
              //         checkRound++;
              //       }
              //     }
              //   }
              // }

              if (booking_round.length > 0) {
                for (let g=0;g < booking_round.length; g++) {
                  for (let h=0;h < booking_round[g].length; h++) {
                    if (!this.$commonFuction.isEmpty(booking_round[g][h]?.week?.id) || !this.$commonFuction.isEmpty(booking_round[g][h]?.week_1?.id)) {
                      params.cant_update_prop = true;
                    }
                    }
                }
              }
              //check booking tồn tại week
              var where_key_book = {
                //week_id: {_is_null: false},
                booking_id: {_eq: this.models.id},
                status: {'_neq': 'ST005'}
              };
              var checkExistBook = await this.$CoreService.checkExistBook(where_key_book);
              if (checkExistBook == true){
                params.cant_update_prop = true;
              }

              if (!params.cant_update_prop) {
                var query_w = DataServices.deleteData('property_week')
                var variables_w = {
                  where_key: {
                    booking_id: {'_eq': returning.id}
                  },
                }
                if (params.property.id != this.models.property.id) {
                  variables_w.where_key.property_id = {'_eq': params.property?.id}
                }
                this.$apollo.mutate({
                  mutation: query_w,
                  variables: variables_w
                })
                // let diff_date = params.end_visit_date.diff(params.start_visit_date, 'days');
                // let start_of_week = params.start_visit_date.startOf('week').day('Monday');
                // let end_of_week = moment(moment(start_of_week).add(13, 'days').format('YYYY/MM/DD')).endOf('week').day(0);
                // let date_week_arr = [{start: start_of_week, end: end_of_week}];
                // for(let i=1; i <= diff_date; i++) {
                //   if(i%days==0 && i != diff_date) {
                //     let start_d = moment(end_of_week.add(2, 'days').format('YYYY/MM/DD')).startOf('week').day('Monday');
                //     // moment(moment(params.start_visit_date).add((i+h), 'days').startOf('week').day('Monday').format('YYYY/MM/DD'));
                //     end_of_week = moment(moment(start_d).add(1, 'days').format('YYYY/MM/DD')).endOf('isoWeek')
                //     date_week_arr.push({start: start_d, end: end_of_week});
                //   }
                // }
                var date_week_arr = this.calculatePeriods(new Date(params.start_visit_date.format("YYYY-MM-DD")), new Date(params.end_visit_date.format("YYYY-MM-DD")));
                console.log("date_week_arr", date_week_arr);
                date_week_arr.map(async m => {
                  const weekMeta = this.getIsoWeekMeta(m.start);
                  let obj_w = {
                    week_number: weekMeta.week_number,
                    date_start: weekMeta.date_start,
                    date_end: moment(m.end).format("YYYY-MM-DD"),
                    booking_id: returning.id,
                    property_id: params.property?.id,
                    index_week_id: `${weekMeta.week_number}${weekMeta.week_year}`
                  }
                  await this.$apollo.mutate({
                      mutation: DataServices.insertData('property_week'),
                      variables: {
                        objects: obj_w
                      }
                  }).catch(async error => {
                      console.log('error', error);
                      this.$toast.add({
                          severity: 'error',
                          summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                          detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
                          life: 3000
                      });
                  });
                })
              }
              if (!params.cant_update_prop) {
                var query_b = DataServices.deleteData('booking_round')
                var variables_b = {
                  where_key: {
                    booking_id: {'_eq': returning.id}
                  },
                }

                await this.$apollo.mutate({
                  mutation: query_b,
                  variables: variables_b
                })
              }
              await this.syncMaintenanceVisits(params);
              if (booking_round.length > 0) {
                for (let i=0;i < booking_round.length; i++) {
                  for (let j=0;j < booking_round[i].length; j++) {
                    const currentRound = booking_round[i][j];
                    const hasExistingWeekChange = currentRound?.is_old === true && this.hasRoundWeekChanged(currentRound);
                    if (hasExistingWeekChange) {
                      try {
                        await this.$CoreService.change_visit_admin({
                          property_id: params.property?.id,
                          uid_book: currentRound?.uid,
                          part_number: currentRound?.part_number,
                          removed_weeks: this.getRemovedWeeks(currentRound).map((week) => ({
                            id: week?.id ?? null,
                            index_week_id: week?.index_week_id ?? null,
                            week_number: week?.week_number ?? null,
                            date_start: week?.date_start ?? null,
                            date_end: week?.date_end ?? null
                          })),
                          added_weeks: this.getAddedWeeks(currentRound).map((week) => ({
                            id: week?.id ?? null,
                            index_week_id: week?.index_week_id ?? null,
                            week_number: week?.week_number ?? null,
                            date_start: week?.date_start ?? null,
                            date_end: week?.date_end ?? null
                          }))
                        });
                      } catch (error) {
                        const errorMessage = error?.response?.data?.message || error?.message || '';
                        if (errorMessage === 'ONLY_NOT_PLAN_YET_CAN_REMOVE') {
                          this.$toast.add({
                            severity: 'warn',
                            summary: 'Warning',
                            detail: 'Only weeks with status "Not plan yet" can be removed.',
                            life: 3000
                          });
                          this.$commonFuction.is_loading(false);
                          return;
                        }
                        throw error;
                      }
                    }
                    let obj = {
                      week_id: currentRound?.week?.id,
                      week_id_1: currentRound?.week_1?.id,
                      round: `${currentRound?.round}`,
                      ordinal: currentRound?.ordinal,
                      status: currentRound?.status ?? 'ST005',
                      part_id: currentRound?.part_id,
                      part_number: currentRound?.part_number,
                      uid: currentRound?.uid,
                      booking_id: returning.id
                    };
                    if (currentRound?.round == 1 && currentRound?.ordinal == 1) {
                      obj.date_start_book = params?.property?.time_zone ? moment.tz(params.start_visit_date, params?.property?.time_zone).format('YYYY/MM/DD') : params.start_visit_date;
                    }
                    if (!this.$commonFuction.isEmpty(currentRound?.week?.id) || !this.$commonFuction.isEmpty(currentRound?.week_1?.id)){
                          if(currentRound?.is_old != true && !hasExistingWeekChange){
                    var params_add_visit = {
                            arr_week_id: [currentRound?.week?.id, currentRound?.week_1?.id],
                            property_id: params.property?.id,
                            uid_book: currentRound?.uid,
                            part_number: currentRound?.part_number,
                          }
                          await this.$CoreService.add_visit_admin(params_add_visit);
                          }
                    }
                   
                    if (params.cant_update_prop) {
                      let variables_ = {
                        'data_update': obj,
                        'where_key': {
                          'id': {'_eq': booking_round[i][j].id}
                        }
                      }
                      await this.$apollo.mutate({
                          mutation: DataServices.updateData('booking_round'),
                          variables: variables_
                      }).then(async () => {
                        if ((i+1) == booking_round.length && (j+1) == booking_round[i].length) {
                          this.redirectEdit();
                        }
                      }).catch(async error => {
                          console.log('error', error);
                          this.$toast.add({
                              severity: 'error',
                              summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                              detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
                              life: 3000
                          });
                          this.$commonFuction.is_loading(false);
                      });
                    } else {
                      await this.$apollo.mutate({
                          mutation: DataServices.insertData('booking_round'),
                          variables: {
                            objects: obj
                          }
                      }).then(async () => {
                        if ((i+1) == booking_round.length && (j+1) == booking_round[i].length) {
                          this.redirectEdit();
                        }
                      }).catch(async error => {
                          console.log('error', error);
                          this.$toast.add({
                              severity: 'error',
                              summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                              detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
                              life: 3000
                          });
                          this.$commonFuction.is_loading(false);
                      });
                    }
                  }
                }
              } else {
                this.redirectEdit();
              }
            }
        }).catch(async error => {
            console.log('error', error);
            this.$toast.add({
                severity: 'error',
                summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
                life: 3000
            });
            this.$commonFuction.is_loading(false);
        });
      }
      this.$commonFuction.is_loading(false);
    },
    async redirectEdit() {
      var that = this;
      var router_back = {path: '/admin/list-booking'};
      that.$commonFuction.is_loading(false);
      if(that.mode == 'add'){
        that.$router.push(router_back);
      }else{
        if (!that.$commonFuction.isEmpty(router_back)){
          // that.page_transaction = ""+that.page_transaction
          router_back.query = { page_transaction: that.page_transaction.toString() };
        }
        that.$router.push(router_back);
      }
      that.$toast.add({ severity: 'success', summary: 'Success', detail: 'Save data successfully', life: 3000 })
    },
    calculatePeriods(startDate, endDate) {
      const periods = [];

      let currentStart = new Date(Date.UTC(
        startDate.getUTCFullYear(),
        startDate.getUTCMonth(),
        startDate.getUTCDate()
      ));
      currentStart.setUTCHours(0, 0, 0, 0);

      const end = new Date(Date.UTC(
        endDate.getUTCFullYear(),
        endDate.getUTCMonth(),
        endDate.getUTCDate()
      ));
      end.setUTCHours(0, 0, 0, 0);

      while (currentStart <= end) {
        let currentEnd = new Date(currentStart.getTime() + (6 * 24 * 60 * 60 * 1000));
        if (currentEnd > end) {
          currentEnd = new Date(end);
        }
        periods.push({
          start: new Date(currentStart),
          end: currentEnd
        });
        currentStart = new Date(currentEnd.getTime() + (1 * 24 * 60 * 60 * 1000));
      }

      return periods;
    },
    async getData(id) {
      var {data} = await this.$apollo.query({
        query: DataServices.getList('booking', {
          "fields" : `id property {id code name time_zone address part {id part order_booking user {id fullname email}}} arr_property_week {id index_week_id week_number date_start date_end} booking_round {id part_id round status ordinal part_user{id fullname email} part_number week{id index_week_id week_number date_start date_end} week_1{id index_week_id week_number date_start date_end} } start_visit_date end_visit_date start_booking_date end_booking_date`
        }),
        variables: {
          where_key: {
            id: {'_eq': id},
            deleted: {'_eq': false}
          }
        },
        fetchPolicy: "network-only"
      })
      var model = data[Object.keys(data)];
      if (model.length > 0) {
        this.models = model[0];
      }
      this.componentKey++;
    },
  },
  apollo: {
    
  }
}
</script>

<style lang="scss">
  .manager-title-custom{
    color: #1D3118;
    font-size: 18px;
    /* margin-bottom: 16px; */
    padding-bottom: 10px;
    /* border-bottom: 1px solid #EEEEEE; */
    font-weight: 700;
  }
.p-inputnumber-buttons-stacked {
  .p-inputnumber-button-group {
    .p-button.p-button-icon-only { padding: 0 !important; }
  }
}
.note{ letter-spacing: 0px; color: #707070; margin-bottom: 24px; padding-top: 10px;}
.p-formgrid { margin: 0;
  .p-panel-header {color: #000000; font-size: 18px; font-weight: bold; background: #EEEEEE;}
  .p-card-field{ padding: 24px;
    .p-field{
      .p-col-fixed { width: 300px; display: inline-block !important; margin: 0;}
      .p-col-width{width:500px !important; border-radius: 5px;
        &.disabled{background: #EEEEEE; border: 0 none; padding: 8px 10px;}
        .file-select{margin: 0;
          input[type="file"]{display: none;}
          .select-button{display: inline-block; cursor: pointer; background: transparent; border-radius: 5px;  color: #000000; font-size: 13px; padding: 3px 16px;  border: 1px solid #B4B4B4;}
        }
        &.pac-target-input{ height: 80px;  word-break: break-all; overflow-wrap: break-word;  resize: none;}
      }
      .box-images{ margin: 0; margin-top: 10px; position: relative;
        .item-img{width: 150px; height: 150px;  margin-right: 8px; margin-bottom: 8px; display: inline-flex; position: relative;
          img{max-width: 100%; height: auto;margin: 0 auto; object-fit: contain; padding: 5px;}
          .button-clear{border-radius: 10px; width: 24px; height: 24px; background: #F5564E; float: right; cursor: pointer; position: absolute; right: 0px;
            img{vertical-align: top;}
          }
        }
      }
      .p-invalid{display: block;}
    }
  }
  .fixed-bottom-toolbar{background: transparent; border: 0 none; margin-top: 22px; border-top: 1px solid #B4B4B4; padding: 0; padding-top: 30px;
    .p-button{width: auto; margin-right: 8px;
      &:last-child{margin-right: 0;}
    }
  }
}
.manager-title-row{
  border-bottom: 1px solid #EEEEEE;
}
.p-toolbar-group-right {
  flex-basis: 30%;
}
.p-button-warning.p-button {
  margin: 0 10px;
}
</style>
